module.exports = __webpack_public_path__ + "img/logo.8639a3c3.jpg";